import Vue from 'vue'
import App from './desktopApp'
import VueBlu from 'vue-bulma2'
import Router from './router/desktop'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import md5 from 'md5'
import VueResource from 'vue-resource'
import 'babel-polyfill'
import 'whatwg-fetch'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import trValidate from 'vee-validate/dist/locale/tr'
import enValidate from 'vee-validate/dist/locale/en'
import VeeValidate, { Validator } from 'vee-validate'
import Meta from 'vue-meta'
import VueCarousel from 'vue-carousel'
import { VueSlideoutPanel } from 'vue2-slideout-panel'

import localeTR from 'element-ui/lib/locale/lang/tr-TR'
import localeEN from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import VueGtm from 'vue-gtm'
import VueI18n from 'vue-i18n'

import Default from './desktop/template/Default'
import NoFooter from './desktop/template/NoFooter'
import ProposalTemplate from './desktop/template/ProposalTemplate'
import Empty from './desktop/template/Empty'
import IBranch from './desktop/template/IBranch'
import languageContents from './locale/lang-tr.json'
import PrivacyPolicyAgreement from '@/shared/widget/legalInfo/agreement/privacyPolicy'
import CommunicationAgreement from '@/shared/widget/legalInfo/agreement/communication'
import UserAgreement from '@/shared/widget/legalInfo/agreement/userAgreement'
import ProposalButtons from '@/shared/widget/proposal/buttons'
import VueHtml2Canvas from 'vue-html2canvas'
import VueRecaptcha from 'vue-recaptcha'
import VueClipboard from 'vue-clipboard2'

// Import CSS
import 'vue-bulma2/dist/css/vue-blu.min.css'
// import 'botui/build/botui.min.css'
// import 'botui/build/botui-theme-default.css'
import './assets/css/style.css'
import './assets/css/desktop.css'
import './assets/js/app.js'
import './assets/js/fetch.2.0.3.js'
// import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'

// import isMobile from 'mobile-device-detect'

// Variables
Vue.prototype.$platform = 'desktop'
Vue.prototype.$isDesktop = true
Vue.prototype.$isMobile = false
Vue.prototype.$isTokenControlActive = false

// Router Language
var lang = 'tr'
lang = (window.location.pathname.indexOf('/en/') === 0 || window.location.pathname === '/en') ? 'en' : 'tr'
var router = new Router(lang)
document.getElementsByTagName('html')[0].setAttribute('lang', lang)

// Vue Use
Vue.use(VueBlu)
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
Vue.use(VueMoment, { moment })
moment.locale(lang)
// Vue.use(Lang, {lang: 'tr', locales: locales})
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyCYeVpmDTIWJU4yX8h47sSC4d6m5a_9Wj4',
    key: 'AIzaSyDkuVuW3GvE3tAjNmykm04RxClVaL4SYrk',
    libraries: 'drawing' // necessary for places input
  }
})

Vue.use(Meta)
Vue.use(VueMask)
Vue.component('slideout-panel', VueSlideoutPanel)
locale.use(lang === 'tr' ? localeTR : localeEN)
Vue.use(VueI18n)
Vue.use(VueCarousel)
Vue.use(VueHtml2Canvas)
Vue.use(VueClipboard)
Vue.component('PrivacyPolicyAgreement', PrivacyPolicyAgreement)
Vue.component('CommunicationAgreement', CommunicationAgreement)
Vue.component('UserAgreement', UserAgreement)
Vue.component('ProposalButtons', ProposalButtons)
Vue.component('vue-recaptcha', VueRecaptcha)

// const options = { // you may define your apiKey, lang and version or skip this.
//   apiKey: 'pdct.1.1.20190315T141255Z.8e91e1c5de945fe2.d3ab76de5e2cb72dd5ce21141f579fecdf4a86f8', // '' by default
//   lang: 'tr_TR', // 'ru_RU' by default
//   version: '2.1' // '2.1' by default
// }

// Vue Config
Vue.config.ignoredElements = ['bot-ui', 'v-touch']
Vue.config.productionTip = true
Vue.prototype.eventHub = new Vue()
Vue.mixin({
  methods: {
    hash: function (text) {
      return md5(text)
    },
    formatDecimal: function (value, currency, fractionDigit = 2) {
      var price
      if (typeof value === 'string' || value instanceof String) {
        price = parseFloat(value.includes(',') ? value.replace(',', '.') : value)
      } else {
        price = parseFloat(value)
      }

      if (!this.isNumeric(price)) return value

      var currenyCode = !this.isNull(currency) ? (currency.trim() === 'TL' ? 'TRY' : currency.trim()) : 'TRY'
      var formattedOutput = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: currenyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: fractionDigit
      })
      return formattedOutput.format(price)
      // return !value ? value : value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,').replace(',', '.')
    },
    formatPhoneNumber: function (phoneNumber) {
      var intlCode = ''
      var cleaned = ('' + phoneNumber).replace(/\D/g, '')
      var match = cleaned.match(/^(90|)?(\d{3})(\d{3})(\d{2})(\d{2})$/) || cleaned.match(/^(444|)?(\d{2})(\d{2})$/)
      if (match) {
        if (match[2] === '000') {
          return [match[3], ' ', match[4], ' ', match[5]].join('')
        }
        intlCode = (match[1] === '90' ? '+90 ' : match[1])
        if (intlCode) {
          return intlCode === '+90 ' ? [intlCode, '(', match[2], ') ', match[3], ' ', match[4], ' ', match[5]].join('') : [intlCode, ' ', match[2], ' ', match[3]].join('')
        } else {
          return ['(', match[2], ')', ' ', match[3], ' ', match[4], ' ', match[5]].join('')
        }
      }
      return null
    },
    intToDecimal: function (value) {
      return Number(value).toFixed(2)
    },
    numberWithCommas: function (value) {
      return !value ? value : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    moneyFormat: function (value) {
      /* 123456   --> "123,456.00"
        1234567  --> "1,234,567.00"
        12345.67 --> "12,345.67" */

      var price
      if (typeof value === 'string' || value instanceof String) {
        price = parseFloat(value.includes(',') ? value.replace(',', '.') : value)
      } else {
        price = parseFloat(value)
      }

      if (!this.isNumeric(price)) return value
      return (price).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    },
    isNull: function (value) {
      return (!value || false)
    },
    getRecaptchaKey: function () {
      return window.getConfig().recaptchaKey
    },
    getMod: function () {
      return window.getConfig().mod
    },
    isLogin: function () {
      var token = window.getToken() || ''

      var userValid = false
      var customer = window.getCustomer()
      userValid = (customer.customerNo) && true

      var tokenValid = token !== null && token.length > 0 && token.split(':').length === 2

      return (tokenValid && userValid)
    },
    isNumber: function (evt) {
      var event = (evt) || window.event
      if (event.type === 'paste') {
        var text = ''
        if (window.clipboardData && window.clipboardData.getData) { // For IE
          text = window.clipboardData.getData('Text')
        } else if (event.clipboardData && event.clipboardData.getData) {
          text = event.clipboardData.getData('Text')
        }
        if (!this.isNumeric(text)) {
          event.preventDefault()
          return false
        } else return true
      } else if (event.type === 'drop') {
        var droppedText = ''
        droppedText = event.dataTransfer.getData('Text')
        if (!this.isNumeric(droppedText)) {
          event.preventDefault()
          return false
        } else return true
      }
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45)) {
        event.preventDefault()
      } else {
        return true
      }
    },
    onPaste: function (evt) {
      return this.isNumber(evt)
    },
    onDragDrop: function (evt) {
      return this.isNumber(evt)
    },
    isNumeric: function (value) {
      if (value === '' || value === undefined) return false
      return !isNaN(value)
    },
    storeCustomerInfo: function (obj) {
      window.setCustomer(obj)
    },

    setCustomerInfo: function (insurant) {
      var customer = window.getCustomer()
      if (customer.customerNo !== 0) {
        insurant.name = customer.name || ''
        insurant.surname = customer.surname || ''
        insurant.email = customer.email || ''
        insurant.tckn = Number(customer.identity) ? (customer.identity || '') : ''
        insurant.phone = customer.mobilePhone && customer.mobilePhone.length === 12 ? customer.mobilePhone.substring(2, 12) : (customer.mobilePhone || '')
        insurant.birthDate = customer.birthDate.split('T')[0] || ''
      }
    },
    removeCustomerInfo: function () {
      var customer = {
        customerNo: 0,
        name: '',
        surname: '',
        fullName: '',
        birthDate: null,
        identity: '',
        mobilePhone: '',
        businessPhone: '',
        email: '',
        communication: {
          phoneNumber: '',
          email: '',
          fullAddress: '',
          address: '',
          info: null
        }
      }
      window.setCustomer(customer)
    },
    controlFileExtension: function (ext) {
      var allowedFileExtension = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg']
      if (allowedFileExtension.includes(ext)) {
        return true
      } else {
        return false
      }
    },
    controlContactFormFileExtension: function (ext) {
      var allowedFileExtension = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg']
      if (allowedFileExtension.includes(ext)) {
        return true
      } else {
        return false
      }
    },
    toUrl: function (text) {
      var trMap = { 'çÇ': 'c', 'ğĞ': 'g', 'şŞ': 's', 'üÜ': 'u', 'ıİ': 'i', 'öÖ': 'o' }
      for (var key in trMap) {
        text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key])
      }
      return text.replace(/\s+/g, '-').toLowerCase()
    },
    toUpperFirstCase: function (text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    gtmEvent (category, action, label, value, event) {
      this.$gtm.trackEvent({
        event: event || null, // Event type [default = 'interaction'] (Optional)
        category: category, //  'target'
        action: action,
        label: label, // 'target-properties'
        value: value,
        noninteraction: false // Optional
      })
    },
    getAffiliation: function () {
      switch (window.location.hostname) {
        case 'www.eurekosigorta.com.tr':
          return 'ESWEB Desktop'
        case 'm.eurekosigorta.com.tr':
          return 'ESWEB Mobil'
        default:
          return 'ESWEB ' + window.location.hostname.replace('.eurekosigorta.com.tr', '').toUpperCase()
      }
    },
    isMobileApp: function () {
      return localStorage.getItem('mobileApp') === 'true'
    },
    parseDateTime: function (customer) {
      var customerInsurantBirthDate = null
      var customerInsuredBirthDate = null

      customerInsurantBirthDate = this.$moment(customer.insurant.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      customerInsuredBirthDate = customer.insured.birthDate ? this.$moment(customer.insured.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null

      customer.insurant.birthDate = customerInsurantBirthDate
      customer.insured.birthDate = customerInsuredBirthDate
      return customer
    },
    captchaLanguage: function () {
      return lang === 'tr' ? 'tr-TR' : 'en-US'
    }
  }
})

// Vue
Vue.use(VueGtm, {
  id: window.getConfig().googleTagManagerKey, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

if (lang === 'tr') {
  Validator.localize(lang, trValidate)
} else {
  Validator.localize(lang, enValidate)
}

Vue.use(VeeValidate, { locale: lang, events: 'blur', fieldsBagName: 'formFields' })

VeeValidate.Validator.extend('verifyPassword', {
  getMessage: field => `Şifre minimum: 4 harf, 1 numara içermelidir`,
  validate: value => {
    // var strongRegex = new RegExp('^(?=.{3,}[a-zA-Z])(?=.{0,}[0-9])')
    var strongRegex = new RegExp('\\b(?=(?:\\d*[A-Za-z]){4,11})(?=(?:[A-Za-z]*\\d){1,8})[A-Za-z\\d]{5,12}\\b')
    return strongRegex.test(value)
  }
})

VeeValidate.Validator.extend('checkTcNum', {
  getMessage: field => `TC kimlik numarası yanlış yazılmıştır`,
  validate: value => {
    if (value.length !== 11) {
      return true
    }
    var tcknValue = value.toString()
    var isEleven = /^[0-9]{11}$/.test(tcknValue)
    var totalX = 0
    for (var i = 0; i < 10; i++) {
      totalX += Number(tcknValue.substr(i, 1))
    }
    var isRuleX = totalX % 10 === Number(tcknValue.substr(10, 1))
    var totalY1 = 0
    var totalY2 = 0
    for (var j = 0; j < 10; j += 2) {
      totalY1 += Number(tcknValue.substr(j, 1))
    }
    for (var k = 1; k < 10; k += 2) {
      totalY2 += Number(tcknValue.substr(k, 1))
    }
    var isRuleY = ((totalY1 * 7) - totalY2) % 10 === Number(tcknValue.substr(9, 0))
    return isEleven && isRuleX && isRuleY
  }
})

VeeValidate.Validator.extend('verifyCheckboxGroup', {
  getMessage: field => 'En az bir tane seçim yapılmalıdır.',
  validate: value => {
    return value.length > 0
  }
})

VeeValidate.Validator.extend('checkPlateNumber', {
  getMessage: field => 'Araç plakası hatalı yazılmıştır.',
  validate: value => {
    var regex, v
    v = value.replace(/\s+/g, '').toUpperCase()
    regex = /^(0[1-9]|[1-7][0-9]|8[01])(([A-Z])(\d{4,5})|([A-Z]{2})(\d{3,4})|([A-Z]{3})(\d{2,3}))$|^(0[1-9]|[1-7][0-9]|8[01])(YK)/
    // regex = /\d{2}\s?[A-Z]{1,3}\s?\d{2,4}|\d{2}\s?(YK)/
    return v.match(regex) != null
  }
})

VeeValidate.Validator.extend('checkSerialNumber', {
  getMessage: field => 'Tescil Belge Sıra No hatalı yazılmıştır.',
  validate: value => {
    var regex, v
    v = value.replace(/\s+/g, '').toUpperCase()
    regex = /^[A-Z]{2}[0-9]{6}/
    return v.match(regex) != null
  }
})

VeeValidate.Validator.extend('validatePhone', {
  getMessage: field => 'Telefon numarasını yanlış yazılmıştır.',
  validate: value => {
    return value.startsWith('2') || value.startsWith('3') || value.startsWith('4') || value.startsWith('5')
  }
})

VeeValidate.Validator.extend('validateMobilePhone', {
  getMessage: field => 'Cep telefonu numarası 5 ile başlamalıdır.',
  validate: value => {
    return value.startsWith('5')
  }
})

VeeValidate.Validator.extend('validateLessThanZeroAmount', {
  getMessage: field => 'Tutar değeri sıfırdan küçük olamaz',
  validate: value => {
    return value > 0
  }
})

VeeValidate.Validator.extend('validateCreditCard', {
  getMessage: field => 'Kredi kartı yanlış yazılmıştır.',
  validate: value => {
    var ccVal = value.split(' ').join('').trim()
    // Check if the number contains only numeric value
    // and is of between 13 to 19 digits
    const regex = new RegExp('^[0-9]{13,19}$')
    if (!regex.test(ccVal)) {
      return true
    }

    let checksum = 0 // running checksum total
    let j = 1 // takes value of 1 or 2

    // Process each digit one by one starting from the last
    for (let i = ccVal.length - 1; i >= 0; i--) {
      let calc = 0
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(ccVal.charAt(i)) * j

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1
        calc = calc - 10
      }

      // Add the units element to the checksum total
      checksum = checksum + calc

      // Switch the value of j
      if (j === 1) {
        j = 2
      } else {
        j = 1
      }
    }

    // Check if it is divisible by 10 or not.
    return (checksum % 10) === 0
  }
})

var i18n = new VueI18n({
  locale: lang, // set locale
  messages: languageContents // set locale messages
})
// Vue.prototype.$lang = i18n

if (lang !== 'tr') {
  import(/* webpackChunkName: "lang-[request]" */ `./locale/lang-${lang}.json`).then(msgs => {
    i18n.setLocaleMessage(lang, msgs[lang])
  })
}

Vue.component('default-layout', Default)
Vue.component('proposal-layout', ProposalTemplate)
Vue.component('no-footer-layout', NoFooter)
Vue.component('empty-layout', Empty)
Vue.component('ibranch-layout', IBranch)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App),
  template: '<App/>',
  components: { App }
})

window.onbeforeunload = function () {
  // If user close browser logout
  if (window.getConfig().mod !== 'dev') { window.deleteLoginItems() }
}

window.onunload = function () {
  // If user close browser logout
  // if (window.getConfig().mod !== 'dev') { window.deleteLoginItems() }
}

window.addEventListener('load', function () {
  var fileref = document.createElement('script')
  fileref.setAttribute('type', 'text/javascript')
  // fileref.setAttribute('src', '//cdn.jsdelivr.net/bluebird/3.5.0/bluebird.min.js')
  fileref.setAttribute('src', '//cdn.jsdelivr.net/npm/bluebird@3.7.2/js/browser/bluebird.min.js')
  document.getElementsByTagName('head')[0].appendChild(fileref)

  /*

  require('./assets/js/firebase.js')

  if (!window.localAndTestHostNames().includes(window.location.hostname)) {
    window.fireBasePerf()
  }

  window.handleOnError = function (e, osName, osVersion, browserName, logCreateTime) {
    console.log('handleOnError is triggered')
    var errorLog = {
      message: '',
      errorStack: '',
      url: '',
      hostname: '',
      pathName: '',
      operatingSystem: '',
      browser: '',
      column: '',
      line: '',
      createDate: ''
    }

    // Get the error properties from the error event object
    var { message, source, lineno, colno, error, currentTarget } = e

    // Not supported in every browser.
    errorLog.column = !colno ? '' : colno
    errorLog.line = !lineno ? '' : lineno
    errorLog.createDate = !logCreateTime ? '' : logCreateTime

    if (source == null && currentTarget) {
      source = currentTarget.location.href.toString()
    }

    errorLog.url = source
    errorLog.hostname = currentTarget.location.hostname
    errorLog.pathName = currentTarget.location.pathname
    errorLog.operatingSystem = (osName + ' ' + osVersion)
    errorLog.browser = browserName
    errorLog.message = message

    errorLog.errorStack = (error && error.stack !== null && error.stack !== '') ? error.stack.toString() : ''

    var errorLogMessage = JSON.stringify(errorLog)

    if (!window.localAndTestHostNames().includes(window.location.hostname)) { // TODO: if control needed to trigger only prod
      window.fireBaseDB().ref('clientLogs').push(errorLogMessage)
    }

    var suppressErrorAlert = true
    // If you return true, then error alerts (like in older versions of
    // Internet Explorer) will be suppressed.
    return suppressErrorAlert
  }

  window.addEventListener('error', e => {
    var device = isMobile.deviceDetect()
    var logCreateTime = moment().format('DD/MM/YYYY HH:mm:ss')
    window.handleOnError(e, device.osName, device.osVersion, device.browserName, logCreateTime)
  })

  window.sendClientLog = function (errorLogMessage) {
    if (!window.localAndTestHostNames().includes(window.location.hostname)) { // TODO: if control needed to trigger only prod
      window.fireBaseDB().ref('clientLogs').push(errorLogMessage)
    }
  }
  */
})



// WEBPACK FOOTER //
// ./src/desktop.js